export default __webpack_public_path__ + "static/media/bars.cd806905.svg";